import alteredIcon from 'img/alteredIcon.png'
import coldFoilIcon from 'img/coldFoilIcon.png'
import cosmosHoloIcon from 'img/cosmosHolo.svg'
import firstEdIcon from 'img/firstEdIcon.png'
import foilIcon from 'img/foilIcon.svg'
import iceCrackedHoloIcon from 'img/iceCrackedHolo.svg'
import linkedLotIcon from 'img/linked-lot.svg'
import marginTaxationIcon from 'img/marginTaxationIcon.svg'
import masterballHoloIcon from 'img/masterballHolo.svg'
import playsetIcon from 'img/playsetIcon.png'
import pokeballHoloIcon from 'img/pokeballHolo.svg'
import productImageNotAvailable from 'img/productImageNotAvailable.png'
import rainbowFoilIcon from 'img/rainbowFoilIcon.png'
import reverseCosmosIcon from 'img/reverseCosmos.svg'
import reverseHoloIcon from 'img/reverseHoloIcon.png'
import reverseIceCrackedIcon from 'img/reverseIceCracked.svg'
import reverseMasterballIcon from 'img/reverseMasterball.svg'
import reversePokeballIcon from 'img/reversePokeball.svg'
import reverseStampedIcon from 'img/reverseStamped.svg'
import signedIcon from 'img/signedIcon.png'
import stampedHoloIcon from 'img/stampedHolo.svg'
import standardTaxationIcon from 'img/standardTaxationIcon.svg'
import { CardExtraAttribute, CountryEdition, FINISH_TYPE_LABELS, IdGame } from 'shared'

export const LISTING_AND_APPRAISAL = 'ListingAndAppraisal'
export const STOCK_DISPLAY = 'StockDisplay'
export const LOCATIONS_PANEL = 'LocationsPanel'
export const PT_INVENTORY = 'PTInventory'
export const ARTICLE_EDIT = 'ArticleEdit'
export const PRICE_SUGGEST_PRESENTER = 'PriceSuggestPresenter'
export const PUBLISH_CHANGES_SUMMARY = 'PublishChangesSummary'
export const PRICING_BOT = 'PricingBot'
export const BACKOFFICE_USER_STOCK = 'BackofficeUserStock'
// The backoffice shows the orders far down the page, where filling the viewport leaves a sliver
export const BACKOFFICE_ORDERS_TABLE_HEIGHT = 800

export const PANEL_LOCATION_PLACEHOLDER = '%*#'
export const ESCAPE_STRING_FOR_EMPTY_COMMENT = '%*#null'

// Name Rails gives to the picking list that collects CT Zero orders (PickingList.find_or_create_cardtrader_zero)
export const CARDTRADER_ZERO_PICKING_LIST_NAME = 'Cardtrader Zero'

export const PRODUCT_IMAGE_NOT_AVAILABLE = productImageNotAvailable

export const FOIL_ICON = foilIcon
export const COLD_FOIL_ICON = coldFoilIcon
export const RAINBOW_FOIL_ICON = rainbowFoilIcon
export const REVERSE_HOLO_ICON = reverseHoloIcon
export const ALTERED_ICON = alteredIcon
export const PLAYSET_ICON = playsetIcon
export const SIGNED_ICON = signedIcon
export const FIRST_EDITION_ICON = firstEdIcon
export const ICE_CRACKED_HOLO_ICON = iceCrackedHoloIcon
export const COSMOS_HOLO_ICON = cosmosHoloIcon
export const STAMPED_HOLO_ICON = stampedHoloIcon
export const REVERSE_STAMPED_ICON = reverseStampedIcon
export const MASTERBALL_HOLO_ICON = masterballHoloIcon
export const REVERSE_MASTERBALL_ICON = reverseMasterballIcon
export const POKEBALL_HOLO_ICON = pokeballHoloIcon
export const REVERSE_POKEBALL_ICON = reversePokeballIcon
export const REVERSE_ICE_CRACKED_ICON = reverseIceCrackedIcon
export const REVERSE_COSMOS_ICON = reverseCosmosIcon
export const LINKED_LOT_ICON = linkedLotIcon
export const STANDARD_TAXATION_ICON = standardTaxationIcon
export const MARGIN_TAXATION_ICON = marginTaxationIcon

export const LIMIT_OF_EDITED_ITEMS_THAT_CAN_BE_SAVED = 9000

export const APP_LANGUAGES = [
  { name: 'English', value: 'en' },
  { name: 'German', value: 'de' },
  { name: 'French', value: 'fr' },
  { name: 'Spanish', value: 'es' },
  { name: 'Italian', value: 'it' },
]

export const APP_CURRENCY = [
  { code: 'EUR', symbol: '€' },
  // { code: 'USD', symbol: '$' },
  { code: 'GBP', symbol: '£' },
].sort((a, b) => a.code.localeCompare(b.code))

export const CONDITIONS = [
  { name: 'MT' },
  { name: 'NM' },
  { name: 'EX' },
  { name: 'GD' },
  { name: 'LP' },
  { name: 'PL' },
  { name: 'PO' },
]

export const CONDITIONS_MAP = {
  0: 'MT',
  1: 'NM',
  2: 'EX',
  3: 'GD',
  4: 'LP',
  5: 'PL',
  6: 'PO',
}

export const CONDITIONS_LOOKUP = {
  MT: 0,
  NM: 1,
  EX: 2,
  GD: 3,
  LP: 4,
  PL: 5,
  PO: 6,
}

export const RARITY_FILTER_MAP = {
  0: 'Tkn',
  1: 'Land',
  2: 'C',
  3: 'U',
  4: 'R',
  5: 'M',
}
export const ERROR_REQUIRED = 'Required!'

export const COUNTRIES = [
  { name: 'Austria', code: 'AT' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Germany', code: 'D' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Spain', code: 'ES' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'Greece', code: 'GR' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Italy', code: 'IT' },
  { name: 'Lichtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Norway', code: 'NO' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russia', code: 'RU' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Ukraine', code: 'UA' },
].sort((a, b) => a.name.localeCompare(b.name))

export const CREATE_LOT_STEPS: {
  [key: string]: {
    idx: number
    label: string
  }
} = {
  SELLER: {
    idx: 0,
    label: '',
  },
  LOT: {
    idx: 1,
    label: 'lot',
  },
  // STRATEGY: {
  //   idx: 2,
  //   label: 'strategy',
  // },
  // ITEMS: {
  //   idx: 3,
  //   label: 'items',
  // },
}

export const VISUAL_ARTICLE_ICONBAR_WIDTH = 65

export type ListingTabId = number

export interface ListingTabMeta {
  id: ListingTabId
  title: string // es: "Task 1", "3 – Seller XYZ", ecc.
  lotId?: number // verrà usato quando collego un lotto
}

export interface ListingTabsState {
  tabs: ListingTabMeta[]
  activeTabId: ListingTabId
}

// stato iniziale: una sola tab "Task 1"
export const makeInitialTabsState = (): ListingTabsState => ({
  tabs: [{ id: 1, title: 'Tab 1' }],
  activeTabId: 1,
})

export interface ExtraAttributesValuesAndImagesMapInterface {
  idGame: IdGame
  // gameName: GameName now is not used. when will be necessary this attribute could be uncommented
  cardExtraAttribute: Array<{
    attribute: CardExtraAttribute
    icons: Array<{
      img: string
      value: string
    }>
    singles: boolean
    sealed: boolean
  }>
  finishType: Array<{
    label: FINISH_TYPE_LABELS
    singles: boolean
    sealed: boolean
  }>
  countryEdition: CountryEdition[]
}

/**
 * If finish type is empty means that exist only regular version
 */
export const EXTRA_ATTRIBUTES_VALUES_AND_IMAGES_MAP: Array<ExtraAttributesValuesAndImagesMapInterface> =
  [
    {
      idGame: IdGame.Magic,
      // gameName: GameName.Magic,
      cardExtraAttribute: [
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        {
          attribute: CardExtraAttribute.Playset,
          icons: [{ img: PLAYSET_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: true },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: true },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Yugioh,
      // gameName: GameName.Yugioh,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.FirstEd,
          icons: [{ img: FIRST_EDITION_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [],
      countryEdition: [CountryEdition.US],
    },
    {
      idGame: IdGame.Pokemon,
      // gameName: GameName.Pokemon,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.FirstEd,
          icons: [{ img: FIRST_EDITION_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        // {
        //   attribute: CardExtraAttribute.ReverseHolo,
        //   icons: [{ img: reverseHoloIcon, value: 'true' }],
        // },
        {
          attribute: CardExtraAttribute.Playset,
          icons: [{ img: PLAYSET_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.STAMPED_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.ICE_CRACKED_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.COSMOS_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.MASTERBALL_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.POKEBALL_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_STAMPED_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_MASTERBALL_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_POKEBALL_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_ICE_CRACKED_HOLO, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.REVERSE_COSMOS_HOLO, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.FAB,
      // gameName: GameName.FAB,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.COLD_FOIL, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.RAINBOW_FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Vanguard,
      // gameName: GameName.Vanguard,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        {
          attribute: CardExtraAttribute.Playset,
          icons: [{ img: PLAYSET_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [],
      countryEdition: [],
    },
    {
      idGame: IdGame.DBS,
      // gameName: GameName.DBS,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.FF,
      // gameName: GameName.FF,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.WS,
      // gameName: GameName.WS,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [],
      countryEdition: [],
    },
    {
      idGame: IdGame.Digimon,
      // gameName: GameName.Digimon,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [],
      countryEdition: [],
    },
    {
      idGame: IdGame.OnePiece,
      // gameName: GameName.OnePiece,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [],
      countryEdition: [],
    },
    {
      idGame: IdGame.Lorcana,
      // gameName: GameName.Lorcana,
      cardExtraAttribute: [
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.BSS,
      // gameName: GameName.BSS,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.SWU,
      // gameName: GameName.BSS,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
        // { attribute: CardExtraAttribute.Foil, icons: [{ img: foilIcon, value: 'true' }] },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Riftbound,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Cyberpunk,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Gundam,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
    {
      idGame: IdGame.Sorcery,
      cardExtraAttribute: [
        {
          attribute: CardExtraAttribute.Signed,
          icons: [{ img: SIGNED_ICON, value: 'true' }],
          singles: true,
          sealed: false,
        },
      ],
      finishType: [
        { label: FINISH_TYPE_LABELS.REGULAR, singles: true, sealed: false },
        { label: FINISH_TYPE_LABELS.FOIL, singles: true, sealed: false },
      ],
      countryEdition: [],
    },
  ]

export const COMMENTS_QUESTIONNAIRE = [
  { code: 0, label: 'commentsAsTaxations', example: 'commentsAsTaxationsExamples' },
]
